import React from "react";

export default function Header() {
  return (
    <header>
      <h1 className="title animate__animated animate__flipInX animate__faster">
        - Wisdom Generator 1.2 -
      </h1>
    </header>
  );
}
